import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastKeyframeAddNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path d="M13.2 10.8H10.8V13.2H13.2V10.8Z" fill={color} />
      <path
        d="M8.99999 10.8C8.33669 10.8 7.79999 11.3367 7.79999 12C7.79999 12.6633 8.33669 13.2 8.99999 13.2H10.8V10.8H8.99999Z"
        fill={color}
      />
      <path
        d="M10.8 13.2V15C10.8 15.6633 11.3367 16.2 12 16.2C12.6633 16.2 13.2 15.6633 13.2 15V13.2H10.8Z"
        fill={color}
      />
      <path
        d="M15 10.8H13.2V13.2H15C15.6633 13.2 16.2 12.6633 16.2 12C16.2 11.3367 15.6633 10.8 15 10.8Z"
        fill={color}
      />
      <path
        d="M12 7.80005C11.3367 7.80005 10.8 8.33675 10.8 9.00005V10.8H13.2V9.00005C13.2 8.33675 12.6633 7.80005 12 7.80005Z"
        fill={color}
      />
      <path
        d="M22.8727 10.7274L19.0547 12L22.8727 13.2726C23.5758 12.5695 23.5758 11.4305 22.8727 10.7274Z"
        fill={color}
      />
      <path
        d="M13.2726 1.12732L12 4.94532L19.0547 12L22.8727 10.7274L13.2726 1.12732Z"
        fill={color}
      />
      <path
        d="M10.7274 1.1273L12 4.9453L13.2726 1.1273C12.5695 0.424201 11.4305 0.424201 10.7274 1.1273Z"
        fill={color}
      />
      <path
        d="M1.12732 10.7274L4.94532 12L12 4.94532L10.7274 1.12732L1.12732 10.7274Z"
        fill={color}
      />
      <path
        d="M1.1273 13.2726L4.9453 12L1.1273 10.7274C0.424201 11.4305 0.424201 12.5695 1.1273 13.2726Z"
        fill={color}
      />
      <path
        d="M10.7274 22.8727L12 19.0547L4.94532 12L1.12732 13.2726L10.7274 22.8727Z"
        fill={color}
      />
      <path
        d="M13.2726 22.8727L12 19.0547L10.7274 22.8727C11.4305 23.5758 12.5695 23.5758 13.2726 22.8727Z"
        fill={color}
      />
      <path
        d="M22.8727 13.2726L19.0547 12L12 19.0547L13.2726 22.8727L22.8727 13.2726Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastKeyframeAddNsk.displayName = 'PlayblastKeyframeAddNsk';
